import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { UrlStats } from '@shared/services/logs/logs.service';
import { NgxDatatableModule } from '@siemens/ngx-datatable';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { DurationPipe } from '@shared/pipe/filter.pipe';
import * as pager from '@shared/pager';

@Component({
  selector: 'app-most-frequent-requests-table',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './most-frequent-requests-table.component.html',
  styleUrl: './most-frequent-requests-table.component.scss',
  imports: [NgxDatatableModule, NgbPopover, DurationPipe, TranslatePipe],
})
export class MostFrequentRequestsTableComponent {
  @Input() cpuConsumingRequests: UrlStats[];
  @Input() print: boolean = false;

  @Output() clickPath = new EventEmitter<UrlStats>();

  constructor(public translate: TranslateService) {}

  protected readonly pager = pager;
}
